// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';

export class LatLong {
  readonly lat: number;
  readonly lng: number;

  constructor(data: { [key: string]: any } = {}) {
    this.lat = data.lat === undefined ? 0 : data.lat;
    this.lng = data.lng === undefined ? 0 : data.lng;
  }

  static zero(): LatLong {
    const zeroValues: ExcludeMethodsDeep<LatLong> = {
      lat: 0,
      lng: 0,
    };
    return new LatLong(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type LatLongWireFormat = {
  lat: number;
  lng: number;
};

type NewLatLongProps = PartialDeep<LatLong, { recurseIntoArrays: true }>;
export const NewLatLong: (props: NewLatLongProps) => LatLong = (props) => new LatLong(props);

type NewLatLongFromWireFormatProps = PartialDeep<LatLongWireFormat, { recurseIntoArrays: true }>;
export const NewLatLongFromWireFormat: (props: NewLatLongFromWireFormatProps) => LatLong = (
  props,
) => new LatLong(props);
